export const QUESTIONS_DATA = [
  {
    id: 1,
    title: 'ФИО',
    description: '',
    isRequired: true,
    type: 'Текст',
  },
  {
    id: 2,
    title: 'Email',
    description: '',
    isRequired: true,
    type: 'Текст',
  },
  {
    id: 3,
    title: 'Телефон',
    description: '',
    isRequired: true,
    type: 'Телефон',
  },
  {
    id: 4,
    title: 'Город проживания',
    description: 'Выпадающий список - все города России',
    isRequired: true,
    type: 'Выбор из списка',
  },
  {
    id: 5,
    title: 'Название учебного заведения',
    description: 'Выпадающий список - все вузы России',
    isRequired: true,
    type: 'Выбор из списка',
  },
  {
    id: 6,
    title: 'Специализация',
    description: 'Открытый вопрос',
    isRequired: true,
    type: 'Текст',
  },
  {
    id: 7,
    title: 'На программе какого уровня Вы учитесь?',
    description: 'Выпадающий список',
    isRequired: true,
    type: 'Выбор из списка',
  },
  {
    id: 8,
    title: 'Форма обучения',
    description: 'Выпадающий список',
    isRequired: true,
    type: 'Выбор из списка',
  },
  {
    id: 9,
    title: 'На каком курсе Вы сейчас учитесь?',
    description: 'Выпадающий список',
    isRequired: true,
    type: 'Выбор из списка',
  },
  {
    id: 10,
    title: 'В случае успешного обучения в Школе, Вы хотели бы перейти работать в ИТ ПСБ? Если да — почему?',
    description: 'Открытый вопрос',
    isRequired: true,
    type: 'Многострочный текст',
  },
  {
    id: 11,
    title: 'У Вас есть возможность обучаться в нерабочее/неучебное время, включая выходные дни (6–10 часов в неделю)?',
    description: 'Открытый вопрос',
    isRequired: true,
    type: 'Многострочный текст',
  },
  {
    id: 12,
    title:
      'У Вас есть возможность проходить обучение на личном компьютере (Windows, Mac, Linux) с использованием Zoom, Телемост и т.д.?',
    description: 'Да/Нет',
    isRequired: true,
    type: 'Выбор из списка',
  },
  {
    id: 13,
    title: 'Работаете ли Вы сейчас? Если да — напишите, пожалуйста, где',
    description: 'Открытый вопрос с выбором варианта ответа',
    isRequired: true,
    type: 'Многострочный текст с вариантами ответа',
  },
];
